/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { GiPayMoney } from 'react-icons/gi';
import * as AbrirCorte from 'views/Recaudacion/Corte/AbrirCorte';
import * as CerrarCorte from 'views/Recaudacion/Corte/CerrarCorte';
import * as BuscarCorte from 'views/Recaudacion/Corte/BuscarCorte';
import * as Caja from 'views/Recaudacion/Caja/index';
import * as DepositosEnGarantia from 'views/Recaudacion/DepositosEnGarantia/RegistroDeBeneficiarios';
import * as ReasignarTerminalNetpay from 'views/Recaudacion/Corte/ReasignarTerminalNetpay';
import * as TiposDeReferenciasDePago from 'views/CatalogosDeRecaudacion/TiposDeReferenciasDePago';
import * as EstadosDePagosExternos from 'views/CatalogosDeRecaudacion/EstadosDePagosExternos';
import * as ReceptoresDePagos from 'views/CatalogosDeRecaudacion/ReceptoresDePagos';
import * as AplicacionPagosExternos from 'views/Recaudacion/PagosExternos';
import * as ConsultaPagosExternos from 'views/Recaudacion/PagosExternos/Consulta';
import * as LeyendasBancarias from 'views/Recaudacion/PagosExternos/LeyendasBancarias';
import * as ReportesDeRecaudacion from 'views/Recaudacion/ReportesDeRecaudacion';
import * as RegistroDePagos from 'views/Recaudacion/RegistroDePagos/index';
import * as Recibo from 'views/CatalogosDeRecaudacion/Recibo';

const VENTANILLA = process.env.REACT_APP_ENV_ALTERN === 'ventanilla';

export default {
  title: 'Recaudación',
  icon: () => <GiPayMoney />,
  children: [
    !VENTANILLA && {
      title: 'Caja',
      withoutLayout: true,
      component: Caja.default,
      permissionConfig: Caja.permissionConfig,
    },
    {
      title: 'Ventanilla',
      withoutLayout: true,
      component: Caja.default,
      permissionConfig: Caja.permissionConfigVentanilla,
      componentProps: { mostrarCobro: false },
    },
    !VENTANILLA && {
      title: 'Corte',
      children: [
        {
          title: 'Abrir Corte',
          component: AbrirCorte.default,
          permissionConfig: AbrirCorte.permissionConfig,
        },
        {
          title: 'Cerrar Corte',
          component: CerrarCorte.default,
          permissionConfig: CerrarCorte.permissionConfig,
        },
        {
          title: 'Buscar Corte',
          component: BuscarCorte.default,
          permissionConfig: BuscarCorte.permissionConfig,
        },
        {
          title: 'Reasignar Terminal de Netpay',
          component: ReasignarTerminalNetpay.default,
          permissionConfig: ReasignarTerminalNetpay.permissionConfig,
        },
      ],
    },
    !VENTANILLA && {
      title: 'Depósitos en Garantía',
      component: DepositosEnGarantia.default,
      permissionConfig: DepositosEnGarantia.permissionConfig,
    },

    !VENTANILLA && {
      title: 'Pagos Externos',
      children: [
        {
          title: 'Tipos de Referencia de Pago',
          component: TiposDeReferenciasDePago.default,
          permissionConfig: TiposDeReferenciasDePago.permissionConfig,
        },
        {
          title: 'Estados de Pagos Externos',
          component: EstadosDePagosExternos.default,
          permissionConfig: EstadosDePagosExternos.permissionConfig,
        },
        {
          title: 'Receptores de Pagos',
          component: ReceptoresDePagos.default,
          permissionConfig: ReceptoresDePagos.permissionConfig,
        },
        {
          title: 'Aplicación',
          component: AplicacionPagosExternos.default,
          permissionConfig: AplicacionPagosExternos.permissionConfig,
        },
        {
          title: 'Consulta',
          component: ConsultaPagosExternos.default,
          permissionConfig: ConsultaPagosExternos.permissionConfig,
        },
        {
          title: 'Leyendas Bancarias',
          component: LeyendasBancarias.default,
          permissionConfig: LeyendasBancarias.permissionConfig,
        },
      ],
    },
    !VENTANILLA && {
      title: 'Reportes de Recaudación',
      component: ReportesDeRecaudacion.default,
      permissionConfig: ReportesDeRecaudacion.permissionConfig,
    },
    !VENTANILLA && {
      title: 'Registro De Pagos',
      component: RegistroDePagos.default,
      permissionConfig: RegistroDePagos.permissionConfig,
    },
    {
      title: 'Consulta de Pagos',
      component: RegistroDePagos.default,
      permissionConfig: RegistroDePagos.permissionConfigConsulta,
      componentProps: { esConsulta: true },
    },
    !VENTANILLA && {
      title: 'Recibo',
      component: Recibo.default,
      permissionConfig: Recibo.permissionConfig,
    },
  ],
};
